angular
	.module 'App.Directive'
	.directive 'scaleByPowerOfTen', () ->
		restrict: 'A'
		require: 'ngModel'
		scope: {
			scaleByPowerOfTen: '@?'
		}
		link: (scope, element, attrs, ngModel) ->
			if !ngModel
				return

			parsedAsInt = parseInt(scope.scaleByPowerOfTen)
			isValidExponent = Number.isInteger(parsedAsInt) && parsedAsInt >= 0
			exponent = if isValidExponent then parsedAsInt else 2
			factor = Math.pow(10, exponent)

			ngModel.$parsers.push (value) ->
				if !value
					return null

				return parseFloat(value).toFixed(exponent) * factor

			ngModel.$formatters.push (value) ->
				if !value
					return null

				return value / factor
